module.exports = __webpack_public_path__ + "assets/img/AdvancedNetwork.86559c6c.png";